<template>
  <div>
    <section-header variants="dividing" size="md">
      <template slot="content">
        <heading level="2" size="md" qaid="allocated-backorder-filters-heading">{{ bp('filter') }}</heading>
      </template>
    </section-header>

    <form @submit.prevent="filterChanged">
      <div class="lg:flex flex-col ">
        <div class="md:flex">
          <div class="flex flex-col md:w-1/3">
            <form-group
              v-model="description"
              type="text"
              name="description"
              :maxlength="30"
              class="md:mr-4 md:flex-grow"
              :label="bp('contactUs.model')"
              qaid="allocated-backorder-description-filter"
              :help-text="descriptionHelpText"
            />
            <form-group
              v-model="orderNumber"
              type="text"
              name="orderNumber"
              :maxlength="30"
              class="md:mr-4 md:flex-grow"
              :label="bp('orderNumber')"
              qaid="allocated-backorder-order-number-filter"
            />
          </div>
          <div class="flex flex-col md:w-1/3">
            <form-group
              v-model="customerPo"
              type="text"
              name="customerPo"
              :maxlength="30"
              class="md:mr-4 md:flex-grow"
              :label="bp('customerPo')"
              qaid="allocated-backorder-customer-po-filter"
            />
            <form-group
              v-model="sku"
              type="text"
              name="sku"
              :maxlength="30"
              class="md:mr-4 md:flex-grow"
              :label="bp('sku')"
              qaid="allocated-backorder-sku-filter"
            />
          </div>
          <div class="flex flex-col md:w-1/3">
            <form-group
              type="checkbox"
              :multi-items="[{value: 'hideUnallocated', checked: hideUnallocated, displayName: bp('hideUnallocated')}]"
              class="mb-0"
              :label="bp('text.orders')"
              name="hide-unallocated"
              qaid="allocated-backorder-hide-unallocated-filter"
              @change="handleCheckboxChange"
            />

            <form-group
              type="checkbox"
              :multi-items="[
                {
                  value: 'hideLinesWithoutComments',
                  checked: hideLinesWithoutComments,
                  displayName: bp('hideLinesWithoutComments'),
                },
              ]"
              name="hide-lines-without-comments"
              class="mb-0"
              qaid="allocated-backorder-hide-lines-without-comments-filter"
              @change="handleCheckboxChange"
            />

            <form-group
              type="checkbox"
              :multi-items="[{value: 'showSoldOut', checked: showSoldOut, displayName: bp('showSoldOut')}]"
              class="mb-0"
              name="show-sold-out"
              qaid="allocated-backorder-show-sold-out-filter"
              @change="handleCheckboxChange"
            />

            <form-group
              type="checkbox"
              :multi-items="[{value: 'showProjectOne', checked: showProjectOne, displayName: bp('showProjectOne')}]"
              class="md:mb-0"
              name="show-project-one"
              qaid="allocated-backorder-show-project-one-filter"
              @change="handleCheckboxChange"
            />
          </div>
        </div>

        <div class="buttons">
          <trek-button primary qaid="allocated-backorder-apply-filters" @click="filterChanged">
            {{ bp('filter') }}
          </trek-button>
          <trek-button secondary qaid="allocated-backorder-clear-filters" @click="clearFilters">
            {{ bp('text.clearFilters') }}
          </trek-button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import FormGroup from '@/components/FormGroup';
import SectionHeader from '@/components/SectionHeader';
import Heading from '@/components/Heading';
import TrekButton from '@/components/TrekButton';

export default {
  name: 'AllocatedBackorderHistoryFilters',
  components: {
    TrekButton,
    FormGroup,
    SectionHeader,
    Heading,
  },
  props: {
    redirectFilterSku: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      hideUnallocated: false,
      hideLinesWithoutComments: false,
      showSoldOut: false,
      showProjectOne: false,
      description: '',
      orderNumber: '',
      customerPo: '',
      sku: '',
    };
  },
  computed: {
    descriptionHelpText() {
      return this.$store.state.locale === 'ko_KR' ? this.bp('backordersAllocated.B2B.helpText') : '';
    },
  },
  mounted() {
    this.sku = this.redirectFilterSku ? this.redirectFilterSku : this.sku;
  },
  methods: {
    filterChanged() {
      this.$emit('changed', {
        hideUnallocated: this.hideUnallocated,
        hideLinesWithoutComments: this.hideLinesWithoutComments,
        showSoldOut: this.showSoldOut,
        showProjectOne: this.showProjectOne,
        description: this.description,
        orderNumber: this.orderNumber,
        customerPo: this.customerPo,
        sku: this.sku,
      });
    },
    clearFilters() {
      this.resetFilters();
      this.filterChanged();
    },
    resetFilters() {
      this.hideUnallocated = false;
      this.hideLinesWithoutComments = false;
      this.showSoldOut = false;
      this.showProjectOne = false;
      this.description = '';
      this.orderNumber = '';
      this.customerPo = '';
      this.sku = '';
    },
    handleCheckboxChange(event) {
      const eventValue = event?.target?.value;

      switch (eventValue) {
        case 'hideUnallocated':
          this.hideUnallocated = event.target.checked;
          break;
        case 'hideLinesWithoutComments':
          this.hideLinesWithoutComments = event.target.checked;
          break;
        case 'showSoldOut':
          this.showSoldOut = event.target.checked;
          break;
        case 'showProjectOne':
          this.showProjectOne = event.target.checked;
          break;
      }
    },
  },
};
</script>
